import {
   CallBackTypes,
   ExtensionAutoAttendantInput,
   ExtensionExternalForwardInput,
   ExtensionFaxInput,
   ExtensionFmFmInput,
   ExtensionHuntGroupInput,
   ExtensionInput,
   ExtensionMailboxInput,
   ExtensionPagingGroupInput,
   ExtensionPhoneInput,
   ExtensionQueueInput,
   ExtensionTypes,
   MailboxInput,
   TimeBasedRouteInput,
} from 'generated/graphql-types';
import { ExtensionDetailSaveEvent } from 'src/app/pages/extension-details/models/extension-detail-form-submit-event';
import { ExtensionDetailSaveModel } from 'src/app/pages/extension-details/models/extension-detail-save.model';
import { ExtensionDetailFormService } from 'src/app/pages/extension-details/services/extension-detail-form.service';

export function getExtensionDetailSaveEvent(
   extension: ExtensionDetailSaveModel,
   formService: ExtensionDetailFormService
): ExtensionDetailSaveEvent {
   let extensionFields: (keyof ExtensionInput)[] = [];
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'name');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'shortName');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'number');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'type');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'timeBasedRoutes');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'adminNotes', 'adminNote');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'extensionNotes', 'extensionNote');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'location', 'locationId');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'timeZone', 'timeZoneId');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'users', 'users');
   extensionFields = formService.addFieldForDirtyControl(extensionFields, 'faxEmailAddresses', 'faxEmailAddresses');
   extensionFields = formService.addFieldForDirtyControl(
      extensionFields,
      'departmentExtensions',
      'departmentExtensions'
   );

   let extensionPhoneFields: (keyof ExtensionPhoneInput)[] | null = null;
   let extensionPagingGroupFields: (keyof ExtensionPagingGroupInput)[] | null = null;
   let extensionAutoAttendantFields: (keyof ExtensionAutoAttendantInput)[] | null = null;
   let extensionExternalForwardFields: (keyof ExtensionExternalForwardInput)[] | null = null;
   let extensionHuntGroupFields: (keyof ExtensionHuntGroupInput)[] | null = null;
   let timeBasedRouteFields: (keyof TimeBasedRouteInput)[] | null = [];
   let extensionMailboxFields: (keyof ExtensionMailboxInput)[] | null = null;
   let mailboxFields: (keyof MailboxInput)[] = [];
   let extensionQueueFields: (keyof ExtensionQueueInput)[] | null = null;
   let extensionFaxFields: (keyof ExtensionFaxInput)[] | null = null;
   let extensionFindMeFollowMeFields: (keyof ExtensionFmFmInput)[] | null = null;
   switch (extension.extension.type) {
      case ExtensionTypes.Phone:
         extensionPhoneFields = [];
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.displayName',
            'displayName'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.defaultAreaCode',
            'defaultAreaCode'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.ringTimeout',
            'ringTimeout'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.enableDtmf',
            'enableDtmf'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.isOtrEnabled',
            'isOtrEnabled'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.secondsToWait',
            'secondsToWait'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.dtmfToPlay',
            'dtmfToPlay'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.defaultPhoneNumber',
            'defaultPhoneNumberId'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.dndStatus',
            'dndStatus'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.office',
            'office'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.forwardToExtension',
            'forwardExtensionId'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.forwardExternalNumber',
            'forwardExternalNumber'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.routeBusyExtension',
            'routeBusyExtensionId'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.routeBusyNullAction',
            'routeBusyNullAction'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.isAutoAnswer',
            'isAutoAnswer'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.isRingAllPhones',
            'isRingAllPhones'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.autoAnswerPhone',
            'autoAnswerPhoneId'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.isAutoAnswerEnabled',
            'isAutoAnswerEnabled'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.routeNoAnswerExtension',
            'routeNoAnswerExtensionId'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.routeNoAnswerNullAction',
            'routeNoAnswerNullAction'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.phones',
            'phones'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.extensionsOrExtensionGroupSupervisees',
            'extensionSupervisees'
         );
         extensionPhoneFields = formService.addFieldForDirtyControl(
            extensionPhoneFields,
            'extensionPhone.extensionsOrExtensionGroupSupervisees',
            'extensionGroupSupervisees'
         );

         timeBasedRouteFields = [];
         mailboxFields = [];
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.password', 'password');
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.emailAddress', 'emailAddress');
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'mailbox.markReadAfterEmail',
            'markReadAfterEmail'
         );
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'mailbox.discardAudioAfterEmail',
            'discardAudioAfterEmail'
         );
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.sayCallerId', 'sayCallerId');
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'mailbox.unavailablePrompt',
            'unavailablePromptId2'
         );
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'extensionPhone.isInNameDirectory',
            'isInNameDirectory'
         );
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.namePrompt', 'namePromptId');
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.busyPrompt', 'busyPromptId');
         if (formService.form.get('mailbox.temporaryUnavailablePrompt')?.dirty) {
            mailboxFields = [...mailboxFields, 'temporaryUnavailablePromptId'];
         }
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'mailbox.operatorExtension',
            'operatorExtensionId'
         );
         break;
      case ExtensionTypes.AutoAttendant:
         extensionAutoAttendantFields = [];
         extensionAutoAttendantFields = formService.addFieldForDirtyControl(
            extensionAutoAttendantFields,
            'extensionAutoAttendant.timeoutSeconds',
            'timeoutSeconds'
         );
         extensionAutoAttendantFields = formService.addFieldForDirtyControl(
            extensionAutoAttendantFields,
            'extensionAutoAttendant.timeoutExtension',
            'timeoutExtensionId'
         );
         extensionAutoAttendantFields = formService.addFieldForDirtyControl(
            extensionAutoAttendantFields,
            'extensionAutoAttendant.firstPromptNotSkippable',
            'firstPromptNotSkippable'
         );
         extensionAutoAttendantFields = formService.addFieldForDirtyControl(
            extensionAutoAttendantFields,
            'extensionAutoAttendant.autoAttendantKeys',
            'autoAttendantKeys'
         );
         extensionAutoAttendantFields = formService.addFieldForDirtyControl(
            extensionAutoAttendantFields,
            'extensionAutoAttendant.autoAttendantPrompts',
            'autoAttendantPrompts'
         );
         extensionAutoAttendantFields = formService.addFieldForDirtyControl(
            extensionAutoAttendantFields,
            'extensionAutoAttendant.timeoutNullAction',
            'timeoutNullAction'
         );
         extensionAutoAttendantFields = formService.addFieldForDirtyControl(
            extensionAutoAttendantFields,
            'extensionAutoAttendant.isTimeoutVoicemailOnly',
            'isTimeoutVoicemailOnly'
         );
         break;

      case ExtensionTypes.ExternalForward:
         extensionExternalForwardFields = [];
         extensionExternalForwardFields = formService.addFieldForDirtyControl(
            extensionExternalForwardFields,
            'extensionExternalForward.forwardToNumber',
            'forwardToNumber'
         );
         extensionExternalForwardFields = formService.addFieldForDirtyControl(
            extensionExternalForwardFields,
            'extensionExternalForward.isPassthroughOriginalCallerId',
            'isPassthroughOriginalCallerId'
         );
         extensionExternalForwardFields = formService.addFieldForDirtyControl(
            extensionExternalForwardFields,
            'extensionExternalForward.isDtmf',
            'isDtmf'
         );
         extensionExternalForwardFields = formService.addFieldForDirtyControl(
            extensionExternalForwardFields,
            'extensionExternalForward.pauseSeconds',
            'pauseSeconds'
         );
         extensionExternalForwardFields = formService.addFieldForDirtyControl(
            extensionExternalForwardFields,
            'extensionExternalForward.dtmf',
            'dtmf'
         );
         break;
      case ExtensionTypes.HuntGroup:
         extensionHuntGroupFields = [];
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.displayName',
            'displayName'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.ringTimeout',
            'ringTimeout'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.routeBusyExtension',
            'routeBusyExtensionId'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.routeBusyNullAction',
            'routeBusyNullAction'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.routeNoAnswerExtension',
            'routeNoAnswerExtensionId'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.isRouteBusyVoicemailOnly',
            'isRouteBusyVoicemailOnly'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.isRouteNoAnswerVoicemailOnly',
            'isRouteNoAnswerVoicemailOnly'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.routeNoAnswerNullAction',
            'routeNoAnswerNullAction'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.callerIdOverride',
            'callerIdOverride'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.huntGroupMembers',
            'huntGroupMembers'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.extensionsOrExtensionGroupMembers',
            'huntGroupMembers'
         );
         extensionHuntGroupFields = formService.addFieldForDirtyControl(
            extensionHuntGroupFields,
            'extensionHuntGroup.extensionsOrExtensionGroupMembers',
            'extensionGroupHuntGroupMembers'
         );
         break;
      case ExtensionTypes.SmartVoicemail:
      case ExtensionTypes.VoiceMailbox:
         extensionMailboxFields = [];
         extensionMailboxFields = formService.addFieldForDirtyControl(
            extensionMailboxFields,
            'extensionMailbox.notes',
            'notes'
         );
         extensionMailboxFields = formService.addFieldForDirtyControl(
            extensionMailboxFields,
            'extensionMailbox.customerNotes',
            'customerNotes'
         );
         mailboxFields = [];
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.password', 'password');
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.emailAddress', 'emailAddress');
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'mailbox.markReadAfterEmail',
            'markReadAfterEmail'
         );
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'mailbox.discardAudioAfterEmail',
            'discardAudioAfterEmail'
         );
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.sayCallerId', 'sayCallerId');
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'mailbox.unavailablePrompt',
            'unavailablePromptId2'
         );
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.namePrompt', 'namePromptId');
         mailboxFields = formService.addFieldForDirtyControl(mailboxFields, 'mailbox.busyPrompt', 'busyPromptId');
         if (formService.form.get('mailbox.temporaryUnavailablePrompt')?.dirty) {
            mailboxFields = [...mailboxFields, 'temporaryUnavailablePromptId'];
         }
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'mailbox.operatorExtension',
            'operatorExtensionId'
         );
         mailboxFields = formService.addFieldForDirtyControl(
            mailboxFields,
            'extensionMailbox.isInNameDirectory',
            'isInNameDirectory'
         );
         break;
      case ExtensionTypes.CallQueue:
         extensionQueueFields = [];
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.announcementFrequency',
            'announcementFrequency'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.holdMusicPrompt',
            'holdMusicPromptId'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.isAnnounceQueueCount',
            'isAnnounceQueueCount'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.isAnnounceCallback',
            'isAnnounceCallback'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.isAnnounceWaitTime',
            'isAnnounceWaitTime'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.isCallBackAvailable',
            'isCallBackAvailable'
         );
         if (formService.form.get('extensionQueue.typeOfCallback')?.value === CallBackTypes.CallersInTheQueue) {
            extensionQueueFields = formService.addFieldForDirtyControl(
               extensionQueueFields,
               'extensionQueue.callersNeededForCallback',
               'callersNeededForCallback'
            );
         }
         if (formService.form.get('extensionQueue.typeOfCallback')?.value === CallBackTypes.ExpectedHoldTime) {
            extensionQueueFields = formService.addFieldForDirtyControl(
               extensionQueueFields,
               'extensionQueue.holdTimeNeededForCallback',
               'holdTimeNeededForCallback'
            );
         }
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.typeOfCallback',
            'callBackType'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.callbackPrompt',
            'customCallbackPromptId'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.queueStrategyId',
            'queueStrategyId'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.wrapUpTime',
            'wrapUpTime'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.exitRouteToExtension',
            'exitRouteTo'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.exitRouteVoicemailOnly',
            'exitRouteVoicemailOnly'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.hasPreventEmptyQueue',
            'hasPreventEmptyQueue'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.queueEmptyExitRouteToExtension',
            'queueEmptyExitRouteTo'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.queueEmptyExitNullAction',
            'queueEmptyExitNullAction'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.periodicAnnouncementFrequency',
            'periodicAnnouncementFrequency'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.queueMembers',
            'queueMembers'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.queuePeriodicAnnouncements',
            'queuePeriodicAnnouncements'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.extensionsOrExtensionQueueGroupMembers',
            'queueMembers'
         );
         extensionQueueFields = formService.addFieldForDirtyControl(
            extensionQueueFields,
            'extensionQueue.extensionsOrExtensionQueueGroupMembers',
            'queueExtensionGroupMembers'
         );
         break;
      case ExtensionTypes.Fax:
         extensionFaxFields = [];
         extensionFaxFields = formService.addFieldForDirtyControl(
            extensionFaxFields,
            'extensionFax.defaultPhoneNumber',
            'defaultPhoneNumberId'
         );
         extensionFaxFields = formService.addFieldForDirtyControl(
            extensionFaxFields,
            'extensionFax.emailAddress',
            'emailAddress'
         );
         break;
      case ExtensionTypes.FindMeFollowMe:
         extensionFindMeFollowMeFields = [];
         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.extensionId',
            'extensionId'
         );
         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.finalDestinationExtension',
            'finalDestinationExtensionId'
         );
         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.isFinalDestinationVoicemail',
            'isFinalDestinationVoicemail'
         );

         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.isIgnoreForward',
            'isIgnoreForward'
         );

         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.isGreetingDisabled',
            'isGreetingDisabled'
         );

         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.isSendOriginalCallerId',
            'isSendOriginalCallerId'
         );

         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.finalDestinationPhoneNumber',
            'finalDestinationPhoneNumber'
         );

         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.defaultPhoneNumber',
            'defaultPhoneNumberId'
         );
         extensionFindMeFollowMeFields = formService.addFieldForDirtyControl(
            extensionFindMeFollowMeFields,
            'extensionFindMeFollowMe.fmFmSteps',
            'fmFmSteps'
         );

         break;
      case ExtensionTypes.PagingGroup:
         extensionPagingGroupFields = [];
         extensionPagingGroupFields = formService.addFieldForDirtyControl(
            extensionPagingGroupFields,
            'extensionPagingGroup.pagingGroupMembersOrExtensionGroupMembers',
            'pagingGroupMembers'
         );
         extensionPagingGroupFields = formService.addFieldForDirtyControl(
            extensionPagingGroupFields,
            'extensionPagingGroup.pagingGroupMembersOrExtensionGroupMembers',
            'pagingGroupExtensionGroups'
         );
         break;
      default:
         break;
   }
   return {
      extension,
      extensionAutoAttendantFields,
      extensionExternalForwardFields,
      extensionFields,
      extensionHuntGroupFields,
      extensionMailboxFields,
      extensionPhoneFields,
      extensionPagingGroupFields,
      extensionQueueFields,
      extensionFaxFields,
      extensionFindMeFollowMeFields,
      mailboxFields,
      timeBasedRouteFields,
   };
}

export function copyNameControlToShortNameAndDisplayName(parentForm: any, form: any): void {
   const nameControl = parentForm.get('name');
   const displayNameControl = form.get('displayName');
   const shortNameControl = parentForm.get('shortName');

   nameControl?.valueChanges.subscribe((newValue) => {
      if (displayNameControl && !displayNameControl?.touched) {
         displayNameControl?.setValue(newValue);
         displayNameControl?.markAsDirty();
         displayNameControl?.updateValueAndValidity();
      }
      if (!shortNameControl?.touched) {
         shortNameControl?.setValue(newValue?.substring(0, 20) ?? null);
         shortNameControl?.markAsDirty();
         shortNameControl?.updateValueAndValidity();
      }
   });
}
